import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { LoadingBar } from '../reusables';

class Table extends Component {
  constructor(props) {
    super(props);

    this.handleSort = this.handleSort.bind(this);
    this.createRows = this.createRows.bind(this);
  }

  handleSort(name) {
    const { handleSort, sort = {} } = this.props;

    if (!!name && !!handleSort) {
      const direction = sort[name] === 'desc' ? 'asc' : 'desc';
      handleSort(name, direction);
    }
  }

  createRows() {
    const { table } = this.props;

    return table.body.map((row, rowIndex) => (
      <tr key={`row-${rowIndex}`}>
        {row.map((column, columnIndex) => (
          <td key={`column-${columnIndex}`}>{column}</td>
        ))}
      </tr>
    ));
  }

  render() {
    const { epcIconIsVisible, animated, classNames, id, isLoading, loadingData, noData, sort = {}, table } = this.props;

    return (
      <div className={classNames.join(' ')} id={id}>
        <table className="table bordered highlight">
          <thead>
            <tr>
              {table.head.map((head, headIndex) => (
                <th
                  className={head.sort ? 'sortable' : undefined}
                  key={`head-${headIndex}`}
                  onClick={() => this.handleSort(head.sort)}
                >
                  <span className="label">
                    {head.component}
                    {!!head.helpLink && epcIconIsVisible ? (
                      <a className="help basic-colors" href={head.helpLink} rel="noreferrer" target="_blank">
                        <i className="material-icons">&#xE88F;</i>
                      </a>
                    ) : null}
                  </span>
                  <i className={['material-icons', sort[head.sort] ? 'sorted' : undefined].join(' ')}>
                    {sort[head.sort] === 'asc' ? 'arrow_upward' : 'arrow_downward'}
                  </i>
                </th>
              ))}
            </tr>
          </thead>
          {animated ? (
            <ReactCSSTransitionGroup
              className="animationTable"
              component="tbody"
              transitionEnterTimeout={table.body.length * 50 + 500}
              transitionLeave={false}
              transitionLeaveTimeout={0}
              transitionName="tablerow"
            >
              {this.createRows()}
            </ReactCSSTransitionGroup>
          ) : (
            <tbody>{this.createRows()}</tbody>
          )}
        </table>
        {table.body.length < 1 &&
          (isLoading ? (
            <span>
              <LoadingBar />
              <div className="loadingResults">{loadingData}</div>
            </span>
          ) : (
            <div className="noResults">{noData}</div>
          ))}
      </div>
    );
  }
}

Table.defaultProps = {
  classNames: [],
  loadingData: 'Loading...',
  noData: 'No data',
};

Table.propTypes = {
  animated: PropTypes.bool,
  classNames: PropTypes.array,
  handleSort: PropTypes.func,
  id: PropTypes.string,
  isLoading: PropTypes.bool,
  loadingData: PropTypes.string,
  noData: PropTypes.any,
  sort: PropTypes.object,
  table: PropTypes.object.isRequired,
};

export default Table;
